/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
// import core & vendor packages 
import { loanStatus } from 'helpers';
import React, { useState, useEffect } from 'react';
import { Row, Col, Form, FormControl, Button } from 'react-bootstrap';

// import components 
import Table from 'components/ReactTable';
import BalanceModal from './components/BalanceModal';

// main component
  const index = ({ requestData, setShowScreen }) => {
  const [data, setData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [modalData, setModalData] = useState();

  const tableColumns = React.useMemo(
    () => [
      { Header: 'Loan Account Number', accessor: 'loan_account_number' },
      { Header: 'Loan Created Date', accessor: 'loan_created_date' },
      { Header: 'Principal Account', accessor: 'principal_account' },
      { Header: 'Interest Rate', accessor: 'interest_rate' },
      { Header: 'Tenure', accessor: 'tenure' },
      { Header: 'Type', accessor: 'type' },
      { Header: 'Status', accessor: 'status' },
    ],
    [],
  );

  const tableData = React.useMemo(
    () =>
      data?.map((dd) => ({
        type: dd?.type,
        tenure: dd?.tenure,
        loan_list: dd?.loans_list,
        status: loanStatus(dd?.status),
        interest_rate: dd?.interest_rate,
        loan_created_date: dd?.loan_created_date,
        principal_account: dd?.principal_account,
        loan_account_number: dd?.loan_account_number,
      })),
    [data],
  );

  const handleBalance = (data) => {
    setModalData(data);
    setOpenModal(true);
  };

  useEffect(() => {
    if (requestData) {
      //   console.log('yeata', requestData?.advances_data);
      setData(requestData?.data?.advances_data);
    }
  }, [requestData]);

  return (
    <div className='loans-container shadow-sm'>
      <div className='box-container blue'>
        <Form.Group className='inline-group'>
          <Form.Label>VIEW RECORD</Form.Label>
        </Form.Group>
      </div>

      <div className='box-container'>
        <div className='view-record'>
          <h4 className='mb-3'>Employee Details</h4>

          <Row className='mb-3'>
            <Col>
              <Form.Group className='inline-group'>
                <Form.Label>Employee Name</Form.Label>

                <FormControl placeholder='DETAILS HERE' value={requestData?.employee_name} />
              </Form.Group>

              <Form.Group className='inline-group'>
                <Form.Label>Employee Position</Form.Label>

                <FormControl placeholder='DETAILS HERE' value={requestData?.employee_position} />
              </Form.Group>

              <Form.Group className='inline-group'>
                <Form.Label>Department</Form.Label>

                <FormControl placeholder='DETAILS HERE' value={requestData?.department} />
              </Form.Group>
            </Col>

            <Col>
              <Form.Group className='inline-group'>
                <Form.Label>Company Email Address</Form.Label>

                <FormControl
                  placeholder='DETAILS HERE'
                  value={requestData?.company_email_address}
                />
              </Form.Group>

              <Form.Group className='inline-group'>
                <Form.Label>Contact Number</Form.Label>

                <FormControl placeholder='DETAILS HERE' value={requestData?.contact_number} />
              </Form.Group>
            </Col>
          </Row>

          <Row className='mb-3'>
            <Col className='table-data'>
              <p className='title'>Loans List</p>

              <Table
                data={tableData}
                columns={tableColumns}
                pagination={['BOTTOM']}
                customAction={(id, data) => {
                  return (
                    <div className='advance-actions'>
                      <Button
                        onClick={() => {
                          handleBalance(data);
                        }}
                        className='decline'
                      >
                        Balance
                      </Button>
                    </div>
                  );
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col className='content-footer'>
              <Button
                className='back-button'
                onClick={() => {
                  setShowScreen(1);
                }}
              >
                Back
              </Button>
            </Col>
          </Row>
        </div>
      </div>

      <BalanceModal openModal={openModal} setOpenModal={setOpenModal} modalData={modalData} />
    </div>
  );
};

export default index;
